document.addEventListener("DOMContentLoaded", () => {

    const botonesMenu = document.querySelectorAll(".contenedor-puntos-producto-favoritos-troncoso");

    botonesMenu.forEach(boton => {

        boton.addEventListener("click", (e) => {

            e.preventDefault();
            e.stopPropagation();

            const menu = boton.parentElement.querySelector(".menu-opciones-producto-favoritos");

            document.querySelectorAll(".menu-opciones-producto-favoritos").forEach(item => {

                if(item !== menu){
                    item.classList.remove("activo");
                }

            });

            menu.classList.toggle("activo");

        });

    });

    document.addEventListener("click", () => {

        document.querySelectorAll(".menu-opciones-producto-favoritos").forEach(menu => {
            menu.classList.remove("activo");
        });

    });

    const botonesCompartir = document.querySelectorAll(".opcion-compartir-producto");

botonesCompartir.forEach(boton => {

    boton.addEventListener("click", async (e) => {

        e.preventDefault();
        e.stopPropagation();

        const tarjeta = boton.closest(".tarjeta-producto-favoritos-troncoso");

        const urlProducto = window.location.origin + tarjeta.dataset.url;

        try {

            await navigator.clipboard.writeText(urlProducto);

            boton.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                Enlace copiado
            `;

            setTimeout(() => {

                boton.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18 8a3 3 0 1 0-2.816-4H15a3 3 0 0 0 .184 1.032l-7.37 3.685a3 3 0 0 0-1.998-.717 3 3 0 1 0 1.998 5.283l7.37 3.685A3 3 0 1 0 15 19a3 3 0 0 0 .184 1.032l-7.37-3.685A3 3 0 0 0 9 12c0-.465-.106-.904-.295-1.295l7.37-3.685C16.57 7.655 17.255 8 18 8Z"/>
                    </svg>
                    Compartir
                `;
                
            }, 2000);

        } catch (error) {

            console.error("Error al copiar enlace:", error);

        }

    });

});

});